type IRoute<R extends string> = {
  path: R;
  build: (p: Params<R>) => string;
};

export function createEndpointRoute<R extends string>(
  routeWithParams: R
): IRoute<R> {
  return {
    path: routeWithParams,
    build: (values: Params<R>) => {
      const replacements = Object.entries(values);
      return replacements.reduce((acc, curr) => {
        const [key, replacement] = curr;
        return acc.replace(`:${key}`, replacement as string);
      }, routeWithParams as string);
    }
  };
}

type ExtractParams<
  Route extends string,
  Variables extends string = never
> = Route extends `/${infer VariableOrPathSegment}/${infer Rest}`
  ? VariableOrPathSegment extends `:${infer Variable}`
    ? Variable | ExtractParams<`/${Rest}`, Variables | Variable>
    : ExtractParams<`/${Rest}`, Variables>
  : Route extends `/${infer VariableOrPathSegment}`
    ? VariableOrPathSegment extends `:${infer Variable}`
      ? Variable
      : never
    : never;

type Params<R extends string> = { [key in ExtractParams<R>]: string };
